import CardDetails from '../CardDetails';

/**
 * The name a service's dashboard card heads with: its platform's name, or for
 * a Value Add or Operator Platform service (which has none), its own name.
 * The service's own name is backend-owned and may be a legacy one, such as
 * "SBC as a Service".
 *
 * @param {{ serviceType: string, platformID?: string, name?: string }} [service]
 * @returns {string | undefined}
 */
const getServiceCardName = (service) =>
    CardDetails(service?.serviceType, service?.platformID)?.serviceName ??
    service?.name;

export default getServiceCardName;
